module.exports = __webpack_public_path__ + "img/test06.27d5f091.jpg";